module.exports = __webpack_public_path__ + "static/media/instagram-relax-desktop.83d83d0a.png";